var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('span',{ref:"titleElement"}),_c('br'),_vm._v(" "),_c('div',{staticClass:"button-wrap"},[_c('button',{class:{toggle: 1, paused: _vm.paused},on:{"click":e => _vm.toggle(e)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }